import {currentAccountCode} from "@/app/utils/Account";

/**
 * @deprecated Use #currentAccountCode()
 * @return {Handlebars.SafeString}
 */
export default function() {
    return new Handlebars.SafeString(currentAccountCode());
}